import {Component} from "react";
import ArrowDown from "../ArrowDown";

export default class SortDropDown extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return(
      <div className={'sort-dropdown'}>
        <div className={'top-sort'}>
          <p>{window.currLanguage === 'fr' ? 'TRIER' : 'SORT'}</p>
          <ArrowDown />
        </div>
        <div className={'sort-menu'}>
          <div className="sort-menu-inner">
            <p onClick={() => window.changeSort('best-selling')}>{window.currLanguage === 'fr' ? 'Meilleurs vendeurs' : 'Best sellers'}</p>
            <p onClick={() => window.changeSort('price-ascending')}>{window.currLanguage === 'fr' ? 'Prix, croissant' : 'Price, ascending'}</p>
            <p onClick={() => window.changeSort('price-descending')}>{window.currLanguage === 'fr' ? 'Prix, décroissant' : 'Price, descending'}</p>
          </div>
        </div>
      </div>
    )
  }
}
